import { render, staticRenderFns } from "./DocUrheberrechtView.vue?vue&type=template&id=caffe17a&scoped=true"
import script from "./DocUrheberrechtView.vue?vue&type=script&lang=js"
export * from "./DocUrheberrechtView.vue?vue&type=script&lang=js"
import style0 from "./DocUrheberrechtView.vue?vue&type=style&index=0&id=caffe17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caffe17a",
  null
  
)

export default component.exports